<template>
  <div>
    <div class="toolbar-container">
      <div class="custom-button-group">
        <button
            v-for="(button, index) in buttons"
            :key="index"
            :class="['custom-button', { active: selectedButton === index }]"
            @click="selectButton(index)"
        >
          {{ button.label }}
        </button>
      </div>

      <!-- 右侧按钮组 (无变化) -->
      <div class="right-button-group">
        <el-button size="default" @click="refreshFiles" title="同步文件最新状态">
          刷新状态
        </el-button>
      </div>
    </div>

    <div
        class="component-container"
        v-loading="isLoading"
        element-loading-text="正在同步文件状态..."
        element-loading-background="rgba(255, 255, 255, 0.8)"
    >
      <keep-alive>
        <component
            :is="buttons[selectedButton].component"
            @startParse="startParse"
            @changeComponent="handleChangeComponent"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import CommonFileTable from '@/components/file_parse/commonFileTable.vue';
import {mapState} from "vuex";
import {refreshAllFile, refreshAllFileV2} from "@/components/file_process_js/main_process";
// 引入 Element Plus 的消息提示
import {ElMessage} from 'element-plus';

export default {
  computed: {
    ...mapState(['stepSign']),
  },

  watch: {
    stepSign(currentSign) {
      if (currentSign > 0) {
        this.componentStepSign = currentSign
      }
    }
  },
  components: {
    CommonFileTable,
  },
  data() {
    return {
      isLoading: false,
      componentStepSign: 0,
      buttons: [
        {label: "普通文件", component: "CommonFileTable"},
      ],
      selectedButton: 0,
    };
  },
  methods: {
    async refreshFiles() {
      this.isLoading = true;
      try {
        await refreshAllFileV2();
      } catch (error) {
        console.error('refreshFiles method caught an error:', error);
      } finally {
        this.isLoading = false;
      }
    },

    // --- 以下方法保持不变 ---
    selectButton(index) {
      this.selectedButton = index;
    },
    handleChangeComponent(index) {
      console.log("handleChangeComponent", index);
      this.$store.commit("setStepSign", 1);
      this.startParse()
    },
    async initFileList() {
    },
    async startParse() {
      this.$emit('switch-tab', "results-by-file");
    },
    getVisible(tapIndex) {
      return this.componentStepSign >= tapIndex
    },
  },

  mounted() {
    this.initFileList()
  }
};
</script>


<style scoped>
.component-container {
  min-height: 200px; /* 你可以根据实际内容调整这个值 */
  position: relative; /* v-loading 需要一个定位上下文 */
}

/* --- 以下样式保持不变 --- */
.toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px; /* 增加一点间距，让布局更美观 */
}

.custom-button-group {
  display: flex;
  align-items: center;
  gap: 24px;
}

.right-button-group {
  display: flex;
}

.custom-button {
  background-color: #ffffff;
  padding: 3px 7px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.3s, color 0.3s;
}

.custom-button:hover {
  background-color: #e0e0e0;
}

.custom-button.active {
  background-color: #409eff;
  color: #fff;
}
</style>